<template>
  <div class="photo-upload">
    <!-- Превью фото -->
    <div v-if="photoUrl" class="photo-preview">
      <img :src="photoUrl" alt="Фото ученика" />
      <button @click="removePhoto" class="btn-remove">×</button>
    </div>

    <!-- Форма загрузки -->
    <div v-else class="upload-area">
      <label for="photo-upload" class="upload-label">
        <input
          id="photo-upload"
          type="file"
          accept="image/*"
          @change="handleFileSelect"
          style="display: none"
        />
        <div class="upload-placeholder">
          <span>+</span>
          <p>Загрузить фото</p>
        </div>
      </label>
    </div>

    <!-- Прогресс загрузки -->
    <div v-if="uploading" class="upload-progress">
      <progress :value="progress" max="100"></progress>
      <span>{{ progress }}%</span>
    </div>

    <!-- Ошибки -->
    <div v-if="error" class="error-message">
      {{ error }}
    </div>
  </div>
</template>

<script>
import TutorialDataService from "../../services/TutorialDataService";
export default {
  props: {
    studentId: {
      type: String,
      required: true,
    },
    initialPhotoUrl: String,
  },

  data() {
    return {
      photoUrl: this.initialPhotoUrl,
      uploading: false,
      progress: 0,
      error: null,
    };
  },

  methods: {
    async handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Проверка размера (5MB)
      if (file.size > 0.5 * 1024 * 1024) {
        this.error = "Файл слишком большой. Максимум 0.5MB";
        return;
      }

      // Проверка типа
      if (!file.type.match("image.*")) {
        this.error = "Можно загружать только изображения";
        return;
      }

      await this.uploadPhoto(file);
    },

    async uploadPhoto(file) {
      this.uploading = true;
      this.progress = 0;
      this.error = null;

      const formData = new FormData();
      formData.append("photo", file);
      let data = {
        studentId: this.studentId,
        formData: formData,
      };
      //  try {
      // const response = await this.$axios.post(
      //   `/api/students/${this.studentId}/photo`,
      //   formData,
      //   {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //     onUploadProgress: (progressEvent) => {
      //       this.progress = Math.round(
      //         (progressEvent.loaded * 100) / progressEvent.total
      //       );
      //     },
      //   }
      // );

      TutorialDataService.sendPhoto(data)
        .then((response) => {
          //this.sClass.id = response.data.id;
          console.log("УСПЕШНО ОТПРАВЛЕНО", response);
          this.photoUrl = response.data.photoUrl;
        })
        .catch((e) => {
          console.log("1111111111", e);
        });

      // this.$emit("photo-uploaded", response.data.photoUrl);
      // } catch (error) {
      //   this.error = error.response?.data?.error || "Ошибка загрузки";
      //   console.error("Upload error:", error);
      // } finally {
      //   this.uploading = false;
      //   this.progress = 0;
      // }
    },

    async removePhoto() {
      if (!confirm("Удалить фото?")) return;

      try {
        await this.$axios.delete(`/api/students/${this.studentId}/photo`);
        this.photoUrl = null;
        this.$emit("photo-removed");
      } catch (error) {
        this.error = "Ошибка удаления фото";
        console.error("Delete error:", error);
      }
    },
  },

  watch: {
    initialPhotoUrl(newUrl) {
      this.photoUrl = newUrl;
    },
  },
};
</script>

<style scoped>
.photo-upload {
  max-width: 300px;
  background-color: white;
}

.photo-preview {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
}

.photo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.btn-remove {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 0, 0, 0.7);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.upload-area {
  width: 200px;
  height: 200px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.upload-placeholder {
  text-align: center;
}

.upload-placeholder span {
  font-size: 48px;
  color: #ccc;
}

.upload-progress {
  margin-top: 10px;
}

.error-message {
  color: red;
  margin-top: 10px;
}
</style>
